__turbopack_context__.v({
  "header": "TableHead-module-scss-module__76-qza__header",
  "option": "TableHead-module-scss-module__76-qza__option",
  "options": "TableHead-module-scss-module__76-qza__options",
  "price": "TableHead-module-scss-module__76-qza__price",
  "title": "TableHead-module-scss-module__76-qza__title",
});
